import http from 'hub-http/clients/apiClient';
import I18n from 'I18n';
import { getPropertyValue } from 'framework-asset-preview-lib/internal/shared/utils/crmObject';
export function fetchCtaDetails(crmObject) {
  const assetId = getPropertyValue(crmObject, 'hs_origin_asset_id');
  if (!assetId) {
    return Promise.resolve(undefined);
  }
  return http.get(`/ctas/v3/placements/${assetId}`, {
    query: {
      includeCtaInfo: true
    }
  });
}
export function getBatchPlacementAnalytics(crmObject) {
  const assetId = getPropertyValue(crmObject, 'hs_origin_asset_id');
  return http.post('/activities/v2/cta/batch/placements/total', {
    query: {
      d1: assetId,
      end: I18n.moment().format('YYYYMMDD'),
      start: '20000101'
    },
    headers: {
      'content-type': 'application/x-www-form-urlencoded'
    }
  });
}